module.exports = __webpack_public_path__ + "static/img/peo01@2x.68b11f50.png";